// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b37040f7","455":"f41a9fba","977":"d811bfbf"}[chunkId] + ".chunk.js";
};